// extracted by mini-css-extract-plugin
export default {"aiBodyGrid":"AiBody_aiBodyGrid__U3lBH"};